<div class="circle w-8 h-8 border-4 border-solid rd-50%"></div>

<style>
	.circle {
		border-color: #27509b transparent #27509b #27509b;
		animation: 0.8s linear 0s infinite normal none running rotate;
	}
	@keyframes rotate {
		0% {
			transform: rotate(0);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
